import axios from '@/lib/axios';
import { PaymentTask } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 1190. 支払タスク固定資産外費用編集
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:task_id/update_non_fixed_asset_amount
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  non_fixed_asset_amount: number;
};

const updateNonFixedAssetAmount = (props: Props): Promise<PaymentTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/update_non_fixed_asset_amount`,
    props
  );
};

export const useUpdateNonFixedAssetAmount = () => {
  return useMutation({
    mutationFn: updateNonFixedAssetAmount,
  });
};
